import { useEffect, useState, useRef } from 'react';
import { Button } from '@usitsdasdesign/dds-react';
import Heading from 'atoms/Heading';
import Icon from 'atoms/Icon';

const PositionStyle = {
  left: 'left-0',
  right: 'right-0'
};

function ActionDropBoxV2({ children, label, onClose, buttons = [], height = 'h-full md:h-80', position = 'left', disableSave = false, triggerRef }) {
  const [direction, setDirection] = useState('bottom');
  const ref = useRef();

  useEffect(() => {
    if (!triggerRef?.current) return;
    const rect = triggerRef.current.getBoundingClientRect();
    const spaceBelow = window.innerHeight - rect.bottom;
    const spaceAbove = rect.top;
    const dropdownHeight = ref.current?.offsetHeight || 320;
    if (spaceBelow < dropdownHeight && spaceAbove > spaceBelow) {
      setDirection('top');
    } else {
      setDirection('bottom');
    }
  }, [triggerRef, children]);

  return (
    <div
      ref={ref}
      className={`
        fixed md:absolute border border-gray-200 overflow-hidden z-[101] bg-white md:p-3 flex flex-col md:justify-between md:w-[19rem] shadow-drop md:mt-1.5 w-full
        ${PositionStyle[position]} 
        ${height} 
        ${direction === 'top' ? 'bottom-auto md:bottom-full md:mb-2' : 'top-0 md:top-auto md:mt-1.5'}
      `}
    >
      <div className="flex-none md:hidden p-2 flex items-center justify-between mb-5">
        <Heading type="h5">{label}</Heading>
        <Icon icon="close__l__stroke" onClick={onClose} />
      </div>
      <div className='flex-1 px-3 md:px-0 overflow-y-auto overflow-x-hidden'>
        {children}
      </div>
      {
        (buttons?.length > 0 && !disableSave) && (
          <div className='md:border-t mt-1 flex justify-end md:justify-center px-3 shadow-boxed md:shadow-none pt-3 pb-3 md:pb-0 flex-none gap-4'>
            {
              buttons.map((button, i) => {
                return (
                  <Button
                    {...button}
                  />
                )
              })
            }
          </div>
        )
      }
    </div>
  );
}

export default ActionDropBoxV2;
